import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton, Tooltip, TooltipProps } from "@mui/material";
import { theme } from "../../Customization/Theme";

// Omitting 'children' from TooltipProps
interface Props extends Omit<TooltipProps, 'children'> {
    title: string;
  }

const AppInfoHelpTooltip = ({ title,...otherProps }: Props) => {
  return (
    <Tooltip title={title} {...otherProps}>
      <IconButton sx={{padding:"4px"}}>
        <InfoIcon style={{fontSize:16, color:theme.palette.default.darkGrey}} />
      </IconButton>
    </Tooltip>
  );
};

export default AppInfoHelpTooltip;
